import styles from "./testimonials.module.css";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    id: 1,
    name: "Binud Panging",
    initials: "BP",
    avatar: "https://lh3.googleusercontent.com/a/ACg8ocKzK-1a0B5XO5GChgW1sCtHjFrwifFaVwJL80X5F3IzSqg=s96-c",
    rating: 5,
    date: "5 months ago",
    review:
      "The campsite offers beautiful nature views, a lakeside restaurant, and fun water activities like boating for a relaxed yet enjoyable experience.",
  },
  {
    id: 2,
    name: "Nomita Banik",
    initials: "NB",
    color: "#267444",
    rating: 5,
    date: "5 months ago",
    review:
      "Best place to visit! Loved the serene environment, the lakeside location is absolutely breathtaking. A perfect getaway from city life.",
  },
  {
    id: 3,
    name: "Jyotz",
    initials: "J",
    color: "#5b6a74",
    rating: 5,
    date: "5 months ago",
    review:
      "Awesome experience! The tents were comfortable and the surroundings were very peaceful. Highly recommended for families and nature lovers.",
  },
];

const StarRating = ({ count = 5 }) => (
  <div className={styles.stars}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />
    ))}
  </div>
);

const Testimonials = () => {
  return (
    <section className={styles.testimonialsSection}>
      <div className={styles.testimonialsInner}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>What Our Guests Say</h2>
          <p className={styles.subtitle}>
            Real experiences from nature lovers who've stayed with us
          </p>
          {/* Overall Rating */}
          <div className={styles.overallRating}>
            <StarRating count={5} />
            <span className={styles.ratingScore}>5.0</span>
            <span className={styles.ratingCount}>· 6 Google reviews</span>
          </div>
        </div>

        {/* Review Cards */}
        <div className={styles.cardsGrid}>
          {reviews.map((r) => (
            <div key={r.id} className={styles.card}>
              <Quote size={28} className={styles.quoteIcon} />
              <p className={styles.reviewText}>{r.review}</p>
              <div className={styles.cardFooter}>
                <div className={styles.reviewerInfo}>
                  {r.avatar ? (
                    <img
                      src={r.avatar}
                      alt={r.name}
                      className={styles.avatar}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : null}
                  <div
                    className={styles.avatarInitials}
                    style={{
                      backgroundColor: r.color || "#267444",
                      display: r.avatar ? "none" : "flex",
                    }}
                  >
                    {r.initials}
                  </div>
                  <div>
                    <p className={styles.reviewerName}>{r.name}</p>
                    <p className={styles.reviewDate}>{r.date}</p>
                  </div>
                </div>
                <StarRating count={r.rating} />
              </div>
            </div>
          ))}
        </div>

        {/* Google CTA */}
        <div className={styles.ctaRow}>
          <a
            href="https://g.page/r/review"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.reviewBtn}
          >
            Write a Review on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
